<template>
  <div
    v-if="visible"
    class="product-approval-result-field"
    :data-approval-result-key="resultKey || undefined"
  >
    <FieldRejectionFeedback
      :value="reasonValue"
      :mode="frfMode"
      :rejected="isActive"
      :templates="templates"
      :actor="actor"
      :error="error"
      @input="onReasonInput"
      @clear-error="$emit('clear-error')"
      @update:rejected="onRejectedUpdate"
    />
  </div>
</template>

<script>
import FieldRejectionFeedback from '@/components/FieldRejectionFeedback/FieldRejectionFeedback.vue';
import {
  isProductApprovalResultRadioSelected,
  PRODUCT_APPROVAL_RESULT_CODE_SELECTED,
  PRODUCT_APPROVAL_RESULT_CODE_UNSELECTED,
  resolveProductRejectReasonText,
} from './productApprovalFieldMeta';

export default {
  name: 'ProductApprovalResultField',
  components: { FieldRejectionFeedback },
  props: {
    fromAdmin: { type: Boolean, default: false },
    draft: { type: String, default: '' },
    savedReason: { type: String, default: '' },
    /** Approval_Request_Result.ResultCode：0/2/4 已选，1 未选 */
    resultCode: { type: [String, Number], default: '' },
    canSave: { type: Boolean, default: false },
    saving: { type: Boolean, default: false },
    forceShow: { type: Boolean, default: false },
    showRejectReason: { type: Boolean, default: true },
    showSave: { type: Boolean, default: false },
    templates: { type: Array, default: () => [] },
    actor: { type: String, default: 'AI' },
    error: { type: String, default: '' },
    /** 用于 Finish 校验失败时定位滚动 */
    resultKey: { type: String, default: '' },
  },
  computed: {
    frfMode() {
      return this.fromAdmin ? 'admin' : 'customer';
    },
    displayReason() {
      return resolveProductRejectReasonText(this.savedReason || this.draft || '');
    },
    reasonValue() {
      if (this.fromAdmin) {
        // 审批编辑：直接用 draft，避免 resolve/trim 干扰输入
        if (this.draft != null) return String(this.draft);
        return resolveProductRejectReasonText(this.savedReason || '');
      }
      return this.displayReason;
    },
    /** 子项 radio：由 ResultCode 控制 */
    isActive() {
      return isProductApprovalResultRadioSelected(this.resultCode);
    },
    visible() {
      if (this.forceShow) return true;
      if (this.fromAdmin) return true;
      if (!this.showRejectReason) return false;
      if (!this.isActive) return false;
      // 供应商：无驳回原因时不占位
      return !!String(this.reasonValue || '').trim();
    },
  },
  methods: {
    onRejectedUpdate(rejected) {
      this.$emit(
        'update:resultCode',
        rejected ? PRODUCT_APPROVAL_RESULT_CODE_SELECTED : PRODUCT_APPROVAL_RESULT_CODE_UNSELECTED,
      );
      if (!rejected) {
        this.$emit('update:draft', '');
      }
    },
    onReasonInput(val) {
      this.$emit('update:draft', val == null ? '' : String(val));
    },
  },
};
</script>

<style lang="scss" scoped>
.product-approval-result-field {
  width: 100%;
  box-sizing: border-box;
}
</style>
